import React from 'react';

const Muhtarliklar = () => {
    const muhtarlar = [
        { sn: 1, mahalle: 'AKARCA', adSoyad: 'Mehmet ÇALIŞKAN', telefon: '05352619986' },
        { sn: 2, mahalle: 'AKÇAY', adSoyad: 'Ali KARAHAN', telefon: '05324004937' },
        { sn: 3, mahalle: 'AŞKARBEYLİ', adSoyad: 'Alatdin PİŞGİN', telefon: '05435551966' },
        { sn: 4, mahalle: 'AZGANLIK', adSoyad: 'Osman YILMAZ', telefon: '05435987978' },
        { sn: 5, mahalle: 'BARBAROS', adSoyad: 'Sebahattin ANLAMAZ', telefon: '05464860202' },
        { sn: 6, mahalle: 'BARIŞTEPE', adSoyad: 'Çiğdem BOZHÜYÜK', telefon: '05010983106' },
        { sn: 7, mahalle: 'BEKBELE', adSoyad: 'Hidayet KINALI', telefon: '05307771549' },
        { sn: 8, mahalle: 'BİTİŞİK', adSoyad: 'Ali KILINÇ', telefon: '05469789335' },
        { sn: 9, mahalle: 'BULUTTEPE', adSoyad: 'Cuma YARAR', telefon: '05067105038' },
        { sn: 10, mahalle: 'BÜYÜKDERE', adSoyad: 'Necati BATMAN', telefon: '05336120713' },
        { sn: 11, mahalle: 'CEBİKE', adSoyad: 'Mahmut DAĞLIOĞLU', telefon: '05322865482' },
        { sn: 12, mahalle: 'CIRTIMAN', adSoyad: 'Abdurrahman YILDIRIM', telefon: '05327944533' },
        { sn: 13, mahalle: 'CUMHURİYET', adSoyad: 'İzzettin DOĞAN', telefon: '05344866969' },
        { sn: 14, mahalle: 'ÇAY', adSoyad: 'Murat KÖMOOĞLU', telefon: '05323862885' },
        { sn: 15, mahalle: 'ÇINARLI', adSoyad: 'Necati BAHRİYELİ', telefon: '05335666189' },
        { sn: 16, mahalle: 'DENİZCİLER', adSoyad: 'Cemal YALÇIN', telefon: '05343508645' },
        { sn: 17, mahalle: 'DUMLUPINAR', adSoyad: 'İbrahim ORAL', telefon: '05448598927' },
        { sn: 18, mahalle: 'ESENTEPE', adSoyad: 'Haci ERDOĞAN', telefon: '05377094264' },
        { sn: 19, mahalle: 'FATİH SULTAN MEHMET', adSoyad: 'Mehmet TÜRKOĞLU', telefon: '05372539334' },
        { sn: 20, mahalle: 'GÜLTEPE', adSoyad: 'Mehmet ÇALIK', telefon: '05333134853' },
        { sn: 21, mahalle: 'GÜRSEL', adSoyad: 'Semir ÖZ', telefon: '05324635163' },
        { sn: 22, mahalle: 'GÜZELÇAY', adSoyad: 'Muhsin BEBEK', telefon: '05070724487' },
        { sn: 23, mahalle: 'HÜRRİYET', adSoyad: 'Nevriz ACIOĞLU', telefon: '05352821672' },
        { sn: 24, mahalle: 'İSMET İNÖNÜ', adSoyad: 'Engin AKTUĞ', telefon: '05423764884' },
        { sn: 25, mahalle: 'KALEDİBİ', adSoyad: 'Bestami DEMİRCİ', telefon: '05436218376' },
        { sn: 26, mahalle: 'KARAYILAN', adSoyad: 'Gökhan BAZ', telefon: '05306116326' },
        { sn: 27, mahalle: 'KAVAKLIOLUK', adSoyad: 'Fethi BAKIR', telefon: '05358375976' },
        { sn: 28, mahalle: 'KOCATEPE', adSoyad: 'Emrah CEREN', telefon: '05378924010' },
        { sn: 29, mahalle: 'KURTULUŞ', adSoyad: 'Hasan ŞANLI', telefon: '05377094284' },
        { sn: 30, mahalle: 'MEYDAN', adSoyad: 'Ramazan GÜNEŞ', telefon: '05355016046' },
        { sn: 31, mahalle: 'MODERNEVLER', adSoyad: 'Mehmet TORUN', telefon: '05365977824' },
        { sn: 32, mahalle: 'MURADİYE', adSoyad: 'Mustafa KESEROĞLU', telefon: '05435575774' },
        { sn: 33, mahalle: 'MUSTAFA KEMAL', adSoyad: 'Birol KORUKLU', telefon: '05366663431' },
        { sn: 34, mahalle: 'NUMUNE', adSoyad: 'Ethem AYSEKİ', telefon: '05326385800' },
        { sn: 35, mahalle: 'ORHANGAZİ', adSoyad: 'Ömer GENÇ', telefon: '05318953796' },
        { sn: 36, mahalle: 'PINARBAŞI', adSoyad: 'Fuat GEZGİN', telefon: '05322535427' },
        { sn: 37, mahalle: 'PİRİREİS', adSoyad: 'Hilda CÖCEN KOKU', telefon: '05344340400' },
        { sn: 38, mahalle: 'SAKARYA', adSoyad: 'Zafer ÖTE', telefon: '05364554890' },
        { sn: 39, mahalle: 'SARISEKİ', adSoyad: 'Özcan KAYAR', telefon: '05413716781' },
        { sn: 40, mahalle: 'SAVAŞ', adSoyad: 'Meral Kireççi GÜRLEK', telefon: '05079531967' },
        { sn: 41, mahalle: 'SUÇIKAĞI', adSoyad: 'Kazım AYTEN', telefon: '05354710376' },
        { sn: 42, mahalle: 'SÜLEYMANİYE', adSoyad: 'Cevat ÇAKIR', telefon: '05347681713' },
        { sn: 43, mahalle: 'YENİŞEHİR', adSoyad: 'Tevfik BİLEN', telefon: '05323172935' },
        { sn: 44, mahalle: 'YILDIRIMTEPE', adSoyad: 'Şerafettin ÖZÇELİK', telefon: '05303833947' },
        { sn: 45, mahalle: 'YUNUSEMRE', adSoyad: 'Ahmet MÜCAHİTOĞLU', telefon: '05376706476' },
    ];

    return (
        <div className="muhtarliklar mt-5">
            <div className="container">
                <div className="muhtarliklar-container">
                    <h1>2025 İSKENDERUN MAHALLE MUHTARLARI</h1>
                    <table className="muhtarliklar-table">
                        <thead>
                            <tr>
                                <th>S.N.</th>
                                <th>MAHALLESİ</th>
                                <th>ADI SOYADI</th>
                                <th>CEP TELEFONU</th>
                            </tr>
                        </thead>
                        <tbody>
                            {muhtarlar.map(muhtar => (
                                <tr key={muhtar.sn}>
                                    <td>{muhtar.sn}</td>
                                    <td>{muhtar.mahalle}</td>
                                    <td>{muhtar.adSoyad}</td>
                                    <td>{muhtar.telefon}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Muhtarliklar;
